import axios from 'axios';

const hostname = window.location.hostname;
const apiUrl = hostname === "localhost" ? `http://${hostname}/api` : `https://${hostname}/api`;

const Api = axios.create({baseURL: apiUrl, maxRedirects: 0});

Api.defaults.headers.post['Content-Type'] ='application/json;charset=utf-8';
Api.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
Api.defaults.withCredentials = true;


export default Api;
 